import { useEffect } from 'react';

function DelMessageForMicroapp(props) {
  useEffect(() => {
    const allmesasgeeles = Array.from(document.querySelectorAll('body > div > .ant-message'));
    return () => {
      Array.from(document.querySelectorAll('body > div > .ant-message'))
        .filter((item) => {
          return allmesasgeeles.indexOf(item) === -1;
        })
        .forEach((item) => {
          item.parentNode.removeChild(item);
        });
    };
  }, []);

  return props.children;
}

export default DelMessageForMicroapp;
